import $ from "cash-dom";
import { mapValue } from "Utilities";
import getZoomValues from "./function_get-zoom-values";

export default function ($wrapper, _focus, _scale) {
    var zoom = getZoomValues(_focus, _scale);
    var [xStr, yStr] = _focus.split(",");
    var xPercent = parseFloat(xStr) / 100;
    var yPercent = parseFloat(yStr) / 100;
    var isPortrait = window.innerHeight > window.innerWidth;
    var factor = 2;

    zoom.x = isPortrait && zoom.scale > 1 ? zoom.x * factor : zoom.x;
    zoom.y = isPortrait && zoom.scale > 1 ? zoom.y * factor : zoom.y;
    zoom.scale = isPortrait && zoom.scale > 1 ? zoom.scale * factor : zoom.scale;

    $wrapper.css({
        transformOrigin: "50% 50%",
        transform: `translate3d(${zoom.x}%, ${zoom.y}%, 0) scale(${zoom.scale})`,
    });

    if ($("body").hasClass("logged-in")) {
        var $dot = $(`<div class="dot"></div>`);

        $dot.css({
            position: "absolute",
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            backgroundColor: "red",
            left: `${xPercent * 100}%`,
            top: `${yPercent * 100}%`,
            transform: "translate3d(-50%, -50%, 0)",
            pointerEvents: "none",
            zIndex: 9999,
        });

        $wrapper.css("position", "relative").append($dot);
    }
}
